import { AffiliatePage } from "@/pages/AffiliatePage";

function App() {
  return (
    <div className="min-h-screen w-full bg-ink text-foreground" style={{ backgroundImage: "url('/background-global.webp')", backgroundRepeat: "repeat-y", backgroundSize: "100% auto", backgroundPosition: "top center" }}>
      <AffiliatePage />
    </div>
  );
}

export default App;
